module.exports = __webpack_public_path__ + "static/media/footerlogo.80c7dfd6.svg";